<template>
 <vTransition id="app"  v-if="loading"></vTransition>
</template>
<script>
import http from './api/http'
export default {
  name: 'App',
   data() {
    return {
      loading:true
    };
  },
  methods: {
  uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

   
  },
  mounted() {
    /* var jsSrc =(navigator.language || navigator.browserLanguage).toLowerCase();
    console.log("这是什么语言",jsSrc)
      if(jsSrc.indexOf('zh')>=0)
      {
        // 假如浏览器语言是中文
      }
      else if(jsSrc.indexOf('en')>=0)
      {
          // 假如浏览器语言是英文
      }
      else
      {
        // 假如浏览器语言是其它语言
      } */

      http.get("webapi/Initialize/sys").then(result => {
        document.title=result.sysConfig.webtitle;
        this.$store.commit('setConfig',result.sysConfig);
        this.$store.commit('setRegion',result.regions);
        //this.$Play.show(result.sysConfig.aliDomain+result.sysConfig.audioUrl);//这里是插入全局播放器的
        this.loading=true
      
    }); 

/*     http.get("webapi/mine/Session","",true).then(result => {

        if(result.code==200)
        {
          this.$store.commit('updataUser',result.userinfo);//更新本地信息
          if(result.userinfo.isPwEmpty===false)
          {
              let self=this;
              setTimeout(function(){
                  self.$Modal.confirm({
                      title: self.$t('security.key_1'),
                      content: '<p>'+self.$t('security.key_2')+'</p>',
                      okText: self.$t('security.key_3'),
                      cancelText: self.$t('security.key_4'),
                      onOk: () => {
                          self.$router.push({path:'/setting'})
                      }
                });
              }, 1000);
           
          }
        }
    });  */
      /** 创建Image对象来发送请求  */
     // console.log("被访问地址",escape(document.referrer))
    let uuid = localStorage.getItem("uuid");
    if (uuid==""||uuid==null) {
        uuid=this.uuid();
        localStorage.setItem("uuid", uuid);
    }
    const baseUrl = process.env.NODE_ENV === 'development' ? this.$config.baseUrl.dev : this.$config.baseUrl.pro
    let img = new Image(1, 1)
    let src = `${baseUrl}webapi/Visit?uuid=${uuid}&referer=${escape(document.referrer)}&page=${escape(window.location.href)}`
    img.src = src
    img.onload = function () {
    } 
    img.onerror = function (e) {
    } 
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue